import { useMemo } from 'react';
import type { FunctionComponent, ReactElement } from 'react';
import { findPersonaByName } from '../../data/Personas';
import type { Persona } from '../../data/Personas';

interface Props {
	personaName?: string;
	render: (persona: Persona) => ReactElement;
}

const PersonaContext: FunctionComponent<Props> = (props: Props) => {
	const { personaName, render } = props;

	const persona = useMemo(
		() => (personaName ? findPersonaByName(personaName) : undefined),
		[personaName]
	);

	return persona ? render(persona) : <div>Persona not found</div>;
};

export default PersonaContext;
